import React, { useMemo, useCallback, useEffect, useRef, useReducer,useState } from 'react'
import style from "./index.module.scss"
import Icon from 'components/Icon/Icon'
import { Action } from 'types/interface'
import { $submitOrders, $orderStatus, $paypalSubscription, $alipaySubscription, $alipaySubscriptionStatus } from 'service/recharge'
import { OK, RouterPaths } from 'utils/constant'
import { PayTypeEnum } from 'types/enum'
import { createAction } from 'store/ActionTypes'
import { useReactRouter } from 'hooks/useReactRouter'
import { $userInfo } from 'service/sign'
// import { isMobileChorme } from 'utils/utils'
import { qsFromResultUrl, toWindowBottom } from 'utils/dom'
import Model from 'components/model'
import Button from 'components/button'
import { RechargeStatus, RechargeProps } from '.'
import GoodsInfo from './GoodsInfo'
import PayList from './Paylist'
import ContactUs from './ContactUs'
import PayQr from './PayQr'
import { filter } from 'utils/filter'
import { UseCoupon } from "../RechargeList"
// import CallApp from 'callapp-lib'
// import { useErrorHint } from 'hooks/useErrorHint'
import wxqrImg from "assets/img/png/wx_qr.jpg"

interface QrType {
  curPay: PayTypeEnum | null
  status: RechargeStatus
  ordersInfo: any,
  showPayPal: boolean,
  paypalLoading: boolean,
  countDownSecond: number,
  failText: string | null,
  sethideusecode?: any;
  hideusecode?: any;
}

function reducer(state: QrType, action: Action) {
  switch (action.type) {
  case "init":
    return Object.assign({}, state, {
      status: RechargeStatus.noselect,
      ordersInfo: null
    })
  case "selectPay":
    return Object.assign({}, state, {
      curPay: action.value,
      status: RechargeStatus.loading
    })
  case "loading":
    return Object.assign({}, state, {
      status: RechargeStatus.loading
    })
  case "setCountDownSecond":
    return Object.assign({}, state, {
      status: RechargeStatus.paying,
      countDownSecond: action.value
    })
  case "countDownEnd":
    return Object.assign({}, state, {
      status: RechargeStatus.fail,
      failText: null
    })
  case "submitOrderFail":
    return Object.assign({}, state, {
      status: RechargeStatus.fail,
      failText: action.value
    })
  default:
    return Object.assign({}, state, {
      [action.type]: action.value
    })
  }
}

const RechargeBoxMobile: React.FC<RechargeProps> = ({ payDatas, curGoods, payType, couponPrice, useCode, Complete, hint, setuseCode, setComplete, sethint,sethideusecode,hideusecode,ismodify,setismodify,setval,val,setcheckoutCoupon,checkoutCoupon}) => {
  // const [hideusecode, sethideusecode] = useState(true)
  // const errHint = useErrorHint()
  const [rechargeState, rechargeDispatch] = useReducer(reducer, {
    curPay: null,
    status: RechargeStatus.noselect,
    ordersInfo: null,
    showPayPal: false,
    paypalLoading: false,
    countDownSecond: 10,
    failText: null
  })
  const { history } = useReactRouter()
  const search = useMemo(qsFromResultUrl, [])
  const renderId = useRef(0)
  const [againCheckResult,setagainCheckResult] = useState()
  const [btn,setbtn] = useState(true)

  // function getQuery(url) {
  //   const index = url.indexOf('?')
  //   const obj = {}
  //   if(index === -1) return obj
  //   const queryStr = url.slice(index + 1)
  //   const arr = queryStr.split('&')
  //   for(const i of arr) {
  //     const keyValue = i.split('=')
  //     obj[keyValue[0]] = keyValue[1]
  //   }
  //   return obj
  // }

  const checkOrder = useCallback(async (order_no, payer_id?, re = false) => {
    try {
      const rid = re === true ? renderId.current : renderId.current + 1
      let data: any
      if (curGoods.alipay_renewable && order_no && order_no.transaction_id && !couponPrice.discount) {
        console.log('couponPrice.discountcouponPrice.discount1', couponPrice.discount)

        data = await $alipaySubscriptionStatus(order_no.subscription_id, order_no.transaction_id)
      } else {
        console.log('couponPrice.discountcouponPrice.discount2', couponPrice.discount)

        data = await $orderStatus(order_no, payer_id)
      }
      if (renderId.current !== rid) return
      if (data.code === 0 && (data.data.paid || data.data.transaction_status === "success")) {
        rechargeDispatch(createAction('status', RechargeStatus.success))
        $userInfo()
      } else {
        if (data.code !== 20001) {
          const rid = renderId.current
          setTimeout(() => {
            if (rid === renderId.current) {
              checkOrder(order_no, payer_id, true)
            }
          }, 3000)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }, [curGoods.alipay_renewable, couponPrice])

  const pingpp = useCallback((obj: any) => {
    window['pingpp'].createPayment(JSON.stringify(obj), function (result, err) {
      // object 需是 Charge/Order/Recharge 的 JSON 字符串
      // 可按需使用 alert 方法弹出 log
      //console.log(JSON.stringify(object));
      console.log("result:" + result)
      console.log("err.msg:" + err.msg)
      console.log("err.extra:" + err.extra)
      if (result === "success") {
        // 只有微信JSAPI (wx_pub)、微信小程序（wx_lite）、QQ 公众号 (qpay_pub)、支付宝小程序（alipay_lite）支付成功的结果会在这里返回，其他的支付结果都会跳转到 extra 中对应的 URL
        rechargeDispatch(createAction('status', RechargeStatus.success))
        checkOrder(search.out_trade_no)
      } else if (result === "fail") {
        // Ping++ 对象 object 不正确或者微信JSAPI/微信小程序/QQ公众号支付失败时会在此处返回
        rechargeDispatch(createAction('status', RechargeStatus.fail))
      } else if (result === "cancel") {
        // 微信JSAPI、微信小程序、QQ 公众号、支付宝小程序支付取消支付
        rechargeDispatch(createAction('status', RechargeStatus.fail))
      }
    })
  }, [checkOrder, search.out_trade_no])
  const alipaySubHandler = useCallback((obj: any) => {
    setagainCheckResult(obj)
    window.location.href = obj.pay_url    
    rechargeDispatch({ type: 'setCountDownSecond', value: 180 })
    checkOrder(obj, null)
  }, [checkOrder])

  // const Isalipay = (protocol,path,param) => {
  //   const options = {
  //     scheme:{
  //       protocol,
  //     },
  //     appstore:'',
  //     fallback:'',
  //     timeout:5000
  //   }
  //   const callLib = new CallApp(options)          
  //   // return new Promise<void>((resolve, reject) => {
  //   callLib.open({
  //     path,
  //     param,
  //     callback : () => {
  //       errHint('请先安装支付宝APP。')
  //       sethideusecode(true)
  //       rechargeDispatch(createAction('status', RechargeStatus.noselect))
  //       // reject()
  //     }
  //   })
  //   //   setTimeout(() => {resolve()},3000)
  //   // })

  // }
  const submitOrders = useCallback(async (id: number, pay: string, re = false) => {
    sethideusecode(false)
    try {
      const rid = re === true ? renderId.current : renderId.current + 1
      let body: any
      if (curGoods.alipay_renewable && pay === PayTypeEnum.alipay_wap && !couponPrice.discount) {
        body = await $alipaySubscription(id, "wap")
      } else {
        body = await $submitOrders(id, pay, couponPrice.coupon_code)
      }

      if (rid !== renderId.current) return
      if (body.code === 0) {
        // const query = "?appId=20000067&url=" + encodeURIComponent(body.data[PayTypeEnum.alipay_wap]?.qr_url)
        
        // dispatch(createAction('setOrdersInfo', body.data))
        if (pay === PayTypeEnum.alipay_wap) {
          if (couponPrice.discount) {
            // Isalipay('alipays',`platformapi/startapp`,getQuery(query))
            // Isalipay('alipays','platformapi',getQuery(body.data[PayTypeEnum.alipay_wap].qr_url))
            window.location.href = body.data[PayTypeEnum.alipay_wap].qr_url
          } else {
            if (curGoods.alipay_renewable) {
              // Isalipay('alipays',body.data.pay_url.substring(0,body.data.pay_url.indexOf('?')).substr(10),getQuery(body.data.pay_url))
              alipaySubHandler(body.data)
            } else {
              // Isalipay('alipays',`platformapi/startapp`,getQuery(query))
              // Isalipay('https://openapi.alipay.com','gateway.do',getQuery(body.data[PayTypeEnum.alipay_wap].qr_url))
              window.location.href = body.data[PayTypeEnum.alipay_wap].qr_url
              // pingpp(body.data.alipay_wap)
            }
          }

        } else if (pay === PayTypeEnum.paypal) {
          window.open(body.data.paypal.approval_url, "_self")
        } else if (pay === PayTypeEnum.wx_native_wap) {
          setagainCheckResult(body.data.order_no)
          window.location.href = body.data.qr_url   
          rechargeDispatch({ type: 'setCountDownSecond', value: 60 })
          checkOrder(body.data.order_no, null)
          // pingpp(body.data.wx_native_wap)
          // if (isMobileChorme()) {
          //   history.push(`${RouterPaths.home}?status=chromeWx_${body.data.order_no}_${curGoods.id}`)
          // }
        } else if (pay === PayTypeEnum.union) {
          window.location.href = body.data[pay].qr_url
        } else if (pay === PayTypeEnum.alipay_wap_intl) {
          window.open(body.data.alipay_wap_intl.url, "_self")
        }

      } else {
        if (body.code !== 20001) {
          rechargeDispatch(createAction(
            "submitOrderFail",
            filter(body.code, body.error)
          ))
        } else {
          rechargeDispatch({ type: "init" })
        }
      }

    } catch (e) {
      sethideusecode(true)
      console.log(e)
      rechargeDispatch(createAction(
        "submitOrderFail",
        e.message
      ))
      // orderTimmerRef.current = setTimeout(() => submitOrders(id, pay), 4000)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curGoods.id, history, pingpp, alipaySubHandler, curGoods.alipay_renewable, couponPrice,sethideusecode])

  const selectPayType = useCallback((pay: PayTypeEnum, e?: React.TouchEvent) => {
    if (e) {
      e.stopPropagation()
      e.preventDefault()
    }
    if (curGoods.service_days) {
      if (pay === PayTypeEnum.paypal) {
        rechargeDispatch(createAction('showPayPal', true))
        return
      }
      // 改变state
      rechargeDispatch(createAction('selectPay', pay))
      if(pay === 'wx_wap') return
      // 下单
      submitOrders(curGoods.id, pay)
    }
  }, [curGoods.id, curGoods.service_days, rechargeDispatch, submitOrders])

  const paypalSub = useCallback(async () => {
    rechargeDispatch(createAction('paypalLoading', true))
    try {
      const rid = renderId.current
      const body = await $paypalSubscription(curGoods.id)
      if (rid !== renderId.current) {
        rechargeDispatch(createAction('paypalLoading', false))
        return
      }
      if (body.status === OK) {
        window.open(body.data.approval_url, "_self")
      } else {
        if (body.code !== 20001) {
          rechargeDispatch(createAction(
            "submitOrderFail",
            filter(body.code, body.error)
          ))
        }
      }
    } catch (e) {
      console.log(e)
      rechargeDispatch(createAction(
        "submitOrderFail",
        e.message
      ))
    }
  }, [curGoods.id])

  const paypalCheckOut = useCallback(async () => {
    rechargeDispatch(createAction('status', RechargeStatus.loading))
    rechargeDispatch(createAction('paypalLoading', true))
    submitOrders(curGoods.id, PayTypeEnum.paypal)
  }, [curGoods.id, submitOrders])

  const countDownEnd = useCallback(() => {
    rechargeDispatch({ type: 'countDownEnd' })
  }, [])

  const againRecharge = useCallback(() => {
    window.location.href = RouterPaths.home
    // if (rechargeState.curPay) {
    //   selectPayType(rechargeState.curPay)
    // }
  }, [])
  const againCheck = () => {
    setbtn(false)
    checkOrder(againCheckResult)
    rechargeDispatch({ type: 'setCountDownSecond', value: 180 })
  }

  useEffect(() => {
    return () => {
      renderId.current += 1
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curGoods, rechargeState.status, rechargeState.curPay])

  useEffect(() => {
    setbtn(true)
    return () => {
      rechargeDispatch({ type: "init" })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curGoods.service_days])

  // 浏览器回退时刷新
  useEffect(() => {
    const handler = (e) => {
      if (e.persisted) {
        window.location.reload()
      }
    }

    window.addEventListener("pageshow", handler)
    return () => window.removeEventListener("pageshow", handler)
  }, [])

  // 支付完成回调页面时判断状态
  useEffect(() => {
    if (search.status) {
      toWindowBottom()
    }
    if (search.status === "success") {
      rechargeDispatch(createAction('status', RechargeStatus.success))
      // if (search.method === 'alipay.trade.wap.pay.return') {
      if(!search.out_trade_no) return
      checkOrder(search.out_trade_no, search.PayerID)
      // }
    } else if (search.status === 'fail' || search.status === 'cancel') {
      rechargeDispatch(createAction('status', RechargeStatus.fail))
    } else if (search.status === 'wx') {
      rechargeDispatch({ type: 'setCountDownSecond', value: 10 })
      checkOrder(search.out_trade_no, null)
    } else if (search.status === 'chromeWx') {
      rechargeDispatch({ type: 'setCountDownSecond', value: 20 })
      checkOrder(search.out_trade_no, null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={style['recharge-box-mobile']}>
      <GoodsInfo status={rechargeState.status} pay={rechargeState.curPay} goodsData={curGoods} curPay={payType} coupon={couponPrice} />
      <PayTitle status={rechargeState.status} />
      {
        rechargeState.status === RechargeStatus.noselect
          ? (
            <PayList
              payDatas={payDatas}
              onSelectPay={selectPayType}
              curPay={payType}
              canAlipaySub={curGoods.alipay_renewable}
              couponPrice={couponPrice}
            />
          )
          : rechargeState.curPay === 'wx_wap' ? (
            <div style={{ display:'flex',alignItems:'center',flexDirection:'column',justifyContent:'space-around' }}>
              <span style={{ fontSize:14, marginBottom:10 }}>长按保存二维码并使用微信扫码</span>
              <img style={{ marginBottom:10 }} className={style.wxqrImg} src={wxqrImg} alt="" />
            </div>
          ) : (
            <PayQr
              couponPrice={couponPrice}
              failText={rechargeState.failText}
              ordersInfo={rechargeState.ordersInfo}
              status={rechargeState.status}
              curPay={rechargeState.curPay}
              paypalSubscription={paypalSub}
              paypalCheckOut={paypalCheckOut}
              countDownSeconds={rechargeState.countDownSecond}
              countDownEnd={countDownEnd}
              againRecharge={againRecharge}
              againCheck={againCheck}
              isMobile={true}
              btn={btn}
              isSpecial={curGoods.special_offer}
              changeSelectAlipaySub={(use: boolean) => { return }}
              isUseAlipaySub={false}
              sethideusecode={sethideusecode}
            />
          )
      }
      {hideusecode && !(rechargeState.curPay === 'wx_wap' && rechargeState.status === RechargeStatus.loading) &&  <div className={style.UseCoupon}> 
        <UseCoupon setcheckoutCoupon={setcheckoutCoupon} checkoutCoupon={checkoutCoupon} val={val} setval={setval} setismodify={setismodify} ismodify={ismodify} goodsId={curGoods.id} setuseCode={setuseCode} useCode={useCode} setComplete={setComplete} Complete={Complete} sethint={sethint} hint={hint} />
      </div>}
      <ContactUs />
      <Model
        loading={rechargeState.paypalLoading}
        show={rechargeState.showPayPal}
        onHide={() => rechargeDispatch(createAction('showPayPal', false))}
      >
        <div className={style["model-paypal"]}>
          <div className={style['model-title']}>
            支付
          </div>
          <div className={style['model-sub']}>
            <span className={style['model-sub-title']}>
              {!couponPrice.discount ? "PayPal自动订阅" : "PayPal手动支付"}
            </span>
            <Button
              title="确定"
              type="bule"
              className={style['model-btn']}
              onClick={!couponPrice.discount ? paypalSub : paypalCheckOut}
            />
          </div>
          {!couponPrice.discount && <div className={style['model-checkout']} onTouchEnd={paypalCheckOut}>
            <span>PayPal手动支付</span>
            <Icon icon="iconicon_skip_" className={style.icon} />
          </div>}
        </div>
      </Model>
    </div>
  )
}

interface PayTitleProps {
  status: RechargeStatus
}

const PayTitle: React.FC<PayTitleProps> = ({ status }) => {
  const text = useMemo(() => {
    switch (status) {
    case RechargeStatus.noselect:
    case RechargeStatus.selectPayPal:
      return "请选择支付方式跳转支付"
    default:
      return ""
    }
  }, [status])

  return (
    <div className={style.title}>
      {text}
    </div>
  )
}

export default React.memo(RechargeBoxMobile)
